import React, { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { getAuditLogDetails, GetAuditLogDetailsRequest, getAuditLogs } from '../../app/userSlice';
import { AuditLog, AuditLogDetails, ApiViewEntityResponse, PaginationResponse } from '../../typings';
import { AuditLogDialog as CommonAuditLogDialog } from '../common/AuditLogDialog';

interface PropTypes {
    handleClose: () => void,
    open: boolean
}

/** Loads through the user slice so failures still surface on the user page. */
export const AuditLogDialog: React.FC<PropTypes> = (props: PropTypes) => {
    const dispatch = useAppDispatch();
    const { id } = useAppSelector(state => state.user);

    const loadAll = useCallback(async (): Promise<PaginationResponse<AuditLog> | null> => {
        const dispatchResult = await dispatch(getAuditLogs(id));
        if (dispatchResult.meta.requestStatus !== "fulfilled") return null;

        const payload = dispatchResult.payload as ApiViewEntityResponse<PaginationResponse<AuditLog>>;
        return payload.data;
    }, [dispatch, id]);

    const loadDetails = useCallback(async (auditLogId: number): Promise<AuditLogDetails | null> => {
        const request: GetAuditLogDetailsRequest = { userId: id, auditLogId };
        const dispatchResult = await dispatch(getAuditLogDetails(request));
        if (dispatchResult.meta.requestStatus !== "fulfilled") return null;

        const payload = dispatchResult.payload as ApiViewEntityResponse<AuditLogDetails>;
        return payload.data;
    }, [dispatch, id]);

    return (
        <CommonAuditLogDialog
            open={props.open}
            handleClose={props.handleClose}
            loadAll={loadAll}
            loadDetails={loadDetails}
        />
    )
}
